<template>
  <div class="my_form">
    <el-dialog
      title="公共附件"
      :visible.sync="visible"
      width="1000px"
      top='25vh'
      :before-close="onClose"
    >
      <el-form :model="form" ref="form" inline>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件名称:" prop="fileName">
              <el-input v-model="form.fileName"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="my-content">
              <customUpload :value="form.fileUrl" @input="handleUpload" :widgetConfig="widget"  />
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import customUpload from '../../onlineForm/components/customUpload.vue';
import { initUserInfo } from '@/store/utils';
import { nameTo_ } from '@/utils/index'; // nameTranslate
import { File } from '@/api/file'
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    dataId: {
      type: [String, Number]
    }
  },
  components: {
    customUpload
  },
  data () {
    return {
      form: {
        fileName: '',
        fileUrl: null,
        tableName: nameTo_(this.$route.query.processDefinitionKey)
      },
      widget: {
        isImage: false,
        showName: '附件',
        fileFieldName: 'uploadFile',
        datasource: {
          datasourceId: '1633723237428891648',
          variableName: 'oaFile' // nameTranslate(nameTo_(this.$route.query.processDefinitionKey), 0)
        },
        column: {
          columnName: 'FILE_URL',
          maxFileCount: 1
        }
      },
      deptList: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = {
          fileName: '',
          fileUrl: null,
          tableName: nameTo_(this.$route.query.processDefinitionKey)
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      if (!this.form.fileUrl) {
        this.$message({
          message: '请上传附件',
          type: 'warning'
        });
        return
      }
      this.form.createUserId = initUserInfo().userId
      this.form.createUserName = initUserInfo().showName
      this.form.deptName = initUserInfo().deptName
      this.form.deptId = initUserInfo().deptId
      this.form.dataId = this.dataId
      File.createdFile(this, {oaFileDto: {...this.form, fileUrl: JSON.parse(this.form.fileUrl)[0].filename}}).then(() => {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        
        this.$emit('handleReceive')
        this.onClose()
      })
    },
    handleUpload(fileList) {
      this.form.fileUrl = fileList
      this.form.fileName = JSON.parse(fileList)[0].name
    },
    onClose() {
      this.$emit('update:visible', false);
    },
    onDialogClose() {
      // 保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>

<style lang="scss">
// :deep(.el-dialog__body) {
//   min-height: 834px;
// }
.my-content{
  .el-form-item__content{
  width:75% !important;
}
}
</style>
